(function () {
  'use strict';

  const FLAG = 'kit_grade2__open_drawer_after_reload';

  const normalize = (v) =>
    (v == null ? '' : String(v)).replace(/\s+/g, ' ').trim().toLowerCase();

  function setFlag() {
    try { sessionStorage.setItem(FLAG, '1'); } catch (e) {}
  }
  function consumeFlag() {
    try {
      const v = sessionStorage.getItem(FLAG);
      if (v === '1') {
        sessionStorage.removeItem(FLAG);
        return true;
      }
    } catch (e) {}
    return false;
  }

  function isDrawerOpen(el){
  if (!el) return false;
  if (el.hasAttribute('open')) return true;
  const c = el.classList;
  return c.contains('is-open') || c.contains('open') || c.contains('active');
}

function lockScroll(){
  // só trava se nós mesmos travarmos
  document.documentElement.dataset.kitLock = '1';
  document.body.dataset.kitLock = '1';
  document.documentElement.classList.add('overflow-hidden');
  document.body.classList.add('overflow-hidden');
}

function unlockScroll(){
  // só destrava se fomos nós que travamos
  if (document.documentElement.dataset.kitLock === '1') {
    document.documentElement.classList.remove('overflow-hidden');
    delete document.documentElement.dataset.kitLock;
  }
  if (document.body.dataset.kitLock === '1') {
    document.body.classList.remove('overflow-hidden');
    delete document.body.dataset.kitLock;
  }
}

function openCartDrawer() {
  // 1) controller do tema
  if (window.cart && typeof window.cart.open === 'function') {
    window.cart.open();
    return true;
  }

  // 2) elemento do drawer
  const el =
    document.querySelector('cart-drawer') ||
    document.getElementById('cart-drawer') ||
    document.getElementById('CartDrawer') ||
    document.querySelector('.cart-drawer') ||
    document.querySelector('[data-cart-drawer]');

  // 3) tenta abrir por método do próprio elemento
  if (el && typeof el.open === 'function') {
    el.open();
    return true;
  }

  // 4) tenta clicar no opener do tema (melhor que fallback)
  const opener =
    document.querySelector('[data-cart-drawer-open]') ||
    document.querySelector('[aria-controls="cart-drawer"]') ||
    document.querySelector('[aria-controls="CartDrawer"]') ||
    document.querySelector('a[href="/cart"]') ||
    document.querySelector('button[name="open-cart"]');

  if (opener) {
    opener.click();
    return true;
  }

  // 5) fallback manual (aqui sim travamos scroll, mas com destrava garantida)
  if (!el) return false;

  el.setAttribute('open', '');
  el.classList.add('is-open', 'active', 'open');

  lockScroll();

  // destravar quando fechar (observer)
  const obs = new MutationObserver(() => {
    if (!isDrawerOpen(el)) {
      unlockScroll();
      obs.disconnect();
    }
  });
  obs.observe(el, { attributes: true, attributeFilter: ['open', 'class', 'aria-hidden'] });

  // destravar também em cliques de fechar comuns
  const closeSelectors = [
    '[data-cart-drawer-close]',
    '[aria-label*="close"]',
    '[aria-label*="fechar"]',
    'button[name="close"]',
    '.drawer__close',
    '.cart-drawer__close'
  ];

  const bindClose = () => {
    closeSelectors.forEach(sel => {
      el.querySelectorAll(sel).forEach(btn => {
        btn.addEventListener('click', () => {
          setTimeout(() => {
            if (!isDrawerOpen(el)) unlockScroll();
          }, 50);
        }, { passive: true });
      });
    });
  };

  bindClose();

  // segurança: se por qualquer motivo o tema fechar e não atualizar classes rápido
  setTimeout(() => {
    if (!isDrawerOpen(el)) unlockScroll();
  }, 1200);

  return true;
}

// ✅ segurança: se ficou travado de um fallback anterior, destrava ao carregar
setTimeout(() => {
  const el =
    document.querySelector('cart-drawer') ||
    document.getElementById('cart-drawer') ||
    document.getElementById('CartDrawer') ||
    document.querySelector('.cart-drawer') ||
    document.querySelector('[data-cart-drawer]');

  if (document.documentElement.dataset.kitLock === '1' && !isDrawerOpen(el)) {
    unlockScroll();
  }
}, 0);

  async function cartAdd(items) {
    const url = (window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js';
    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    });
    if (!res.ok) {
      let err = null;
      try { err = await res.json(); } catch (e) {}
      throw new Error(err?.description || err?.message || `HTTP ${res.status}`);
    }
    return res.json();
  }

  function init() {
    const root = document.querySelector('[data-kit-grade2]');
    if (!root) return;

    const limit = parseInt(root.dataset.kitLimit || '12', 10) || 12;
    const requireExact = String(root.dataset.requireExact || 'true') === 'true';

    const totalEl = root.querySelector('[data-kit-total]');
    const statusEl = root.querySelector('[data-kit-status]');
    const errorEl = root.querySelector('[data-error]');

    const cta = root.querySelector('[data-cta]');
    const ctaText = root.querySelector('[data-cta-text]');
    const loading = root.querySelector('[data-loading]');

    const productData = {}; // productId -> json
    const state = {};       // productId -> { sizeKey -> qty }

    root.querySelectorAll('script[data-kit-json]').forEach(s => {
      try {
        const d = JSON.parse(s.textContent);
        productData[String(d.productId)] = d;
        state[String(d.productId)] = {};
      } catch (e) {}
    });

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
      setTimeout(() => { errorEl.hidden = true; }, 4200);
    }

    function setLoading(on) {
      if (!cta || !ctaText || !loading) return;
      loading.hidden = !on;
      ctaText.hidden = on;
      if (on) cta.disabled = true;
    }

    function getTotal() {
      let total = 0;
      Object.keys(state).forEach(pid => {
        Object.values(state[pid]).forEach(q => total += Number(q) || 0);
      });
      return total;
    }

    function setStatus(total) {
      if (totalEl) totalEl.textContent = String(total);

      if (!statusEl) return;

      if (requireExact) {
        if (total < limit) statusEl.textContent = `Faltam ${limit - total} unidade(s)`;
        
        else statusEl.textContent = 'Ajuste as quantidades';
      } else {
        statusEl.textContent = `Limite: ${limit}`;
      }
    }

    function updateCTA() {
      const total = getTotal();
      setStatus(total);

      if (!cta) return;

      if (requireExact) {
        if (total === limit) {
          cta.disabled = false;
          ctaText.textContent = 'ADICIONAR AO CARRINHO';
        } else {
          cta.disabled = true;
          ctaText.textContent = 'ADICIONAR AO CARRINHO';
        }
      } else {
        if (total > 0 && total <= limit) {
          cta.disabled = false;
          ctaText.textContent = 'ADICIONAR AO CARRINHO';
        } else {
          cta.disabled = true;
          ctaText.textContent = 'Selecione as quantidades';
        }
      }
    }

    // ✅ NOVO: resolve variante por tamanho SEM travar por outras opções
    function resolveVariantId(pid, sizeValue) {
      const d = productData[String(pid)];
      if (!d) return null;

      const vars = d.variants || [];
      if (!vars.length) return null;

      // Se o item é "Único" (sem tamanho detectável), pega a primeira variante disponível
      if (sizeValue === '__single__') {
        const v0 = vars.find(v => v.available) || vars[0];
        return v0 ? v0.id : null;
      }

      // Descobre índice do tamanho:
      let pos = Number(d.sizeOptionPos || 0);
      let idx = pos > 0 ? (pos - 1) : -1;

      // fallback: se tem 1 opção só, assume que é ela
      if (idx < 0 && (d.options || []).length === 1) idx = 0;

      // Se mesmo assim não achou, tenta por “title” (muitos produtos usam Title)
      if (idx < 0) idx = 0;

      const wanted = normalize(sizeValue);

      // pega a primeira variante disponível que bate o tamanho
      const hit = vars.find(v => {
        if (!v.available) return false;
        const vopts = v.options || [];
        return normalize(vopts[idx]) === wanted;
      });

      // se não achar disponível, ainda assim tenta achar qualquer uma (pra não matar a coluna)
      const any = vars.find(v => {
        const vopts = v.options || [];
        return normalize(vopts[idx]) === wanted;
      });

      return (hit || any) ? (hit || any).id : null;
    }

    // ✅ Habilitar/desabilitar colunas por disponibilidade real
    root.querySelectorAll('[data-kit-item]').forEach(item => {
      const pid = item.dataset.productId;

      item.querySelectorAll('[data-size]').forEach(col => {
        const sizeVal = col.dataset.size || '';
        const variantId = resolveVariantId(pid, sizeVal);

        const soldout = col.querySelector('[data-soldout]');
        const plus = col.querySelector('[data-pm="plus"]');
        const minus = col.querySelector('[data-pm="minus"]');
        const input = col.querySelector('[data-qty]');

        if (!variantId) {
          col.classList.add('is-disabled');
          if (soldout) soldout.hidden = false;
          if (plus) plus.disabled = true;
          if (minus) minus.disabled = true;
          if (input) input.disabled = true;
        } else {
          col.classList.remove('is-disabled');
          if (soldout) soldout.hidden = true;
          if (plus) plus.disabled = false;
          if (minus) minus.disabled = false;
          if (input) input.disabled = false;
        }
      });
    });

    function clampInputToLimit(pid, col, nextValue) {
      const sizeVal = col.dataset.size || '';
      const key = normalize(sizeVal);

      const total = getTotal();
      const current = Number(state[String(pid)][key] || 0);
      const remaining = limit - (total - current);

      const clamped = Math.max(0, Math.min(Number(nextValue) || 0, Math.max(0, remaining)));
      return clamped;
    }

    root.addEventListener('click', (e) => {
      const pm = e.target.closest('[data-pm]');
      if (!pm) return;

      const col = pm.closest('[data-size]');
      const item = pm.closest('[data-kit-item]');
      if (!col || !item) return;

      if (col.classList.contains('is-disabled')) return;

      const pid = item.dataset.productId;
      const input = col.querySelector('[data-qty]');
      if (!input || input.disabled) return;

      const key = normalize(col.dataset.size || '');

      let current = parseInt(input.value || '0', 10);
      if (Number.isNaN(current)) current = 0;

      let next = current;
      if (pm.dataset.pm === 'plus') next = current + 1;
      else next = Math.max(0, current - 1);

      const fixed = clampInputToLimit(pid, col, next);
      if (fixed !== next) showError(`Limite do kit: ${limit} unidades.`);

      input.value = String(fixed);
      state[String(pid)][key] = fixed;

      updateCTA();
    });

    root.addEventListener('input', (e) => {
      const input = e.target.closest('[data-qty]');
      if (!input) return;

      const col = input.closest('[data-size]');
      const item = input.closest('[data-kit-item]');
      if (!col || !item) return;

      if (col.classList.contains('is-disabled')) return;

      const pid = item.dataset.productId;
      const key = normalize(col.dataset.size || '');

      let raw = String(input.value || '').replace(/[^\d]/g, '');
      if (raw === '') raw = '0';

      let next = parseInt(raw, 10);
      if (Number.isNaN(next)) next = 0;
      next = Math.max(0, Math.min(999, next));

      const fixed = clampInputToLimit(pid, col, next);
      if (fixed !== next) showError(`Limite do kit: ${limit} unidades.`);

      input.value = String(fixed);
      state[String(pid)][key] = fixed;

      updateCTA();
    });

    cta.addEventListener('click', async (e) => {
      e.preventDefault();
      if (cta.disabled) return;

      const total = getTotal();
      if (requireExact && total !== limit) {
        showError(`Complete exatamente ${limit} unidades.`);
        return;
      }
      if (!requireExact && (total <= 0 || total > limit)) {
        showError(`Selecione até ${limit} unidades.`);
        return;
      }

      const items = [];

      Object.keys(state).forEach(pid => {
        const perSize = state[pid] || {};
        Object.keys(perSize).forEach(sizeKey => {
          const qty = Number(perSize[sizeKey] || 0);
          if (qty <= 0) return;

          const itemEl = root.querySelector(`[data-kit-item][data-product-id="${pid}"]`);
          if (!itemEl) return;

          const col = [...itemEl.querySelectorAll('[data-size]')].find(c => normalize(c.dataset.size) === sizeKey);
          if (!col) return;

          const sizeValue = col.dataset.size || '';
          const variantId = resolveVariantId(pid, sizeValue);

          if (!variantId) return;
          items.push({ id: variantId, quantity: qty });
        });
      });

      if (!items.length) {
        showError('Nenhuma combinação válida selecionada.');
        return;
      }

      setLoading(true);

      try {
        await cartAdd(items);
        setFlag();
        window.location.reload();
      } catch (err) {
        showError(err.message || 'Erro ao adicionar ao carrinho.');
        setLoading(false);
      }
    });

    if (consumeFlag()) {
      setTimeout(() => openCartDrawer(), 450);
    }

    updateCTA();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();